/* global Sys */
Sys.ns("Sys");

/**
 * The data model for global resources.
 *
 * Instantiates itself.
 *
 * @deprecated 8.0.0. Will be replaced by an instance of Core.Model.
 * @class Sys.Resources
 * @extends Sys.Observable
 * @static
 */
Sys.Resources = {

    constructor: function() {
        var me = this;

        Sys.Resources.superclass.constructor.apply(me, arguments);

        me.init();
    },

    init: function() {
        this.data = {};
    },

    /**
     * Returns the data linked to the given key.
     *
     * @param {string} key The data storage key.
     * @returns {*} The data read from storage.
     */
    readData: function(key) {
        return this.data[key];
    },

    /**
     * Store the given data under the given key.
     *
     * @param {string} key The name of the key under which to store the data.
     * @param {*} dataToStore The data to store.
     * @returns {*} The data that was stored.
     */
    storeData: function(key, dataToStore) {
        this.data[key] = dataToStore;

        this.fireEvent("notify:resources.dataStored", key);

        return this.data[key];
    },

    /**
     * @deprecated
     * @param {string} key Audio key.
     * @returns {void}
     */
    processAudio: function(key) {
        var me = this,
            audio = me.readData(key),
            AudioContext = window.AudioContext,
            context = new AudioContext(),
            audioBuffer;

        context.decodeAudioData(
            audio,
            // On success:
            function(buffer) {
                audioBuffer = buffer;

                me.storeData("decoded:" + key, {
                    context: context,
                    buffer: audioBuffer
                });

                me.fireEvent("notify:resources.soundDecoded");
            },
            function() {
                // On error:
            }
        );
    },

    /**
     * Remove the object property.
     *
     * @param {string} key The data storage key.
     * @returns {void}
     */
    removeData: function(key) {
        delete this.data[key];
    }

};

Sys.Resources = Sys.extend(Sys.Observable, Sys.Resources, "Sys.Resources");
